import { round } from "../utils";

export const computeDiscount = ({
  totalPriceBeforeDiscount,
  discountRatio,
}: {
  totalPriceBeforeDiscount: number;
  discountRatio: number | null;
}) => {
  const discount = round((totalPriceBeforeDiscount * (discountRatio || 0)) / 100);

  const totalPriceAfterDiscount = totalPriceBeforeDiscount - discount;

  return {
    discount,
    totalPriceAfterDiscount,
  };
};
